import React from 'react';

const PatientHeader = ({ patient }) => {
  const defaultPatient = {
    name: "John Doe",
    age: 58,
  };
  
  const patientData = patient || defaultPatient;
  
  return (
    <div className="bg-white p-4 flex justify-between items-center rounded-lg shadow mb-4">
      <h2 className="text-xl font-medium">Patient: {patientData.name}, {patientData.age}</h2>
      <button className="px-5 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
        Export
      </button>
    </div>
  );
};

export default PatientHeader;